<div fxLayout="column" id="price-container" fxLayoutGap="16px">
  <div fxLayout="column" fxLayoutGap="8px" class="border border-gray-300 p-3">
    <div fxLayout="row" class="p-2">
      <h2>Charges</h2>
    </div>
    <div fxLayout="row" class="p-2">
      <div fxFlex="50" class="key">Delivery:</div>
      <div fxFlex="50" class="value" *ngIf="deliveryTotal" id="delivery-value">
        {{ deliveryTotal | currency : paymentableCurrency : 'symbol' }}
      </div>
    </div>
    <div fxLayout="row" class="p-2">
      <div fxFlex="50" class="key">Sub Total:</div>
      <div fxFlex="50" class="value">
        {{ subtotal | currency : paymentableCurrency : 'symbol' }}
      </div>
    </div>
    <div fxLayout="row" *ngIf="taxRate" class="p-2">
      <div fxFlex="50" class="key">
        Tax &#64; {{ taxRate | percent : '1.0-2' }}:
      </div>
      <div fxFlex="50" class="value">
        {{ tax | currency : paymentableCurrency : 'symbol' }}
      </div>
    </div>
    <div fxLayout="row" class="p-2">
      <div fxFlex="50" class="key">Total:</div>
      <div fxFlex="50" class="value" id="total-value">
        {{ total | currency : paymentableCurrency : 'symbol' }}
      </div>
    </div>
  </div>
  <div fxLayout="column" fxLayoutGap="8px" class="border border-gray-300 p-3">
    <div fxLayout="row" fxLayoutAlign="start center" class="p-2">
      <h2>Payments</h2>
    </div>
    <div fxLayout="row" class="p-2">
      <div fxFlex="50" class="key">Paid:</div>
      <div fxFlex="50" class="value">
        {{ paid | currency : paymentableCurrency : 'symbol' }}
      </div>
    </div>
    <div fxLayout="row" class="bg-gray-500 font-black p-2">
      <div fxFlex="50" class="key">Balance:</div>
      <div fxFlex="50" class="value" id="balance-value">
        {{ balance | currency : paymentableCurrency : 'symbol' }}
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button
        mat-raised-button
        data-cy="add-payment"
        (click)="viewAddPaymentDialog()"
      >
        Add/View Payments
      </button>
    </div>
  </div>
</div>
